import React from "react";
import type { KgBusinessRulesIconProps } from "./KgBusinessRulesIcon.types";

/** Scale / business-rules icon (matches KG secondary sidebar). */
export const KgBusinessRulesIcon: React.FC<KgBusinessRulesIconProps> = ({
  size = 16,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M10.6667 10.6673L12.6667 5.33398L14.6667 10.6673C14.0867 11.1007 13.3867 11.334 12.6667 11.334C11.9467 11.334 11.2467 11.1007 10.6667 10.6673Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33325 10.6673L3.33325 5.33398L5.33325 10.6673C4.75325 11.1007 4.05325 11.334 3.33325 11.334C2.61325 11.334 1.91325 11.1007 1.33325 10.6673Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66675 14H11.3334"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 2V14"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 4.66732H3.33333C4.66667 4.66732 6.66667 4.00065 8 3.33398C9.33333 4.00065 11.3333 4.66732 12.6667 4.66732H14"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KgBusinessRulesIcon;
